import {Euler, Vector3} from 'virtual-tour-viewer/src/modules/React360Proxy';
import PitchYawCameraController from './PitchYawCameraController';
import CameraUtils from '../utils/CameraUtils';
import Event from '../utils/Event';

export default class FixedPointCameraController extends PitchYawCameraController {
    _handledEventEvent: Event;

    constructor({shouldHoldGaze, verticalBumper, velocity = 0}) {
        super({shouldHoldGaze, verticalBumper, defaultRotation: [0, 0, 0, 1], velocity});
        this._handledEventEvent = new Event();
    }

    subscribeHandledEvent(callback) {
        this._handledEventEvent.subscribe(callback);
    }

    _publishHandledEvent(eventArgs) {
        this._handledEventEvent.publish(this, eventArgs);
    }

    /**
     * @param point Vec3, Vector3, or Euler
     */
    setPoint(point) {
        this._publishHandledEvent({method: 'setPoint'});
        let eulerAngles = point;
        if (point instanceof Vector3) {
            eulerAngles = CameraUtils.getEulerFromVector3(point);
        } else if (!(point instanceof Euler)) {
            eulerAngles = CameraUtils.getEulerFromVec3(point);
        }
        this.pan({pitch: eulerAngles.x, yaw: eulerAngles.y}, this._velocity);
    }
}
